export const changeCdnDomain = (value: string, domain: string): string => {
  const splittedArray = value.split('/')
  splittedArray.splice(0, 3, domain)
  return splittedArray.join('/')
}
